// ─────────────────────────────────────────────────────────────────────────────
// Material.js
// ─────────────────────────────────────────────────────────────────────────────
import { useState, useEffect } from 'react';
import api from '../api';

export function Material() {
  const [items, setItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ pos_nr: '', bezeichnung: '', einheit: 'St', bestand: '', min_bestand: '5', baustelle_id: '' });
  const [baustellen, setBaustellen] = useState([]);
  const [editing, setEditing] = useState(null);

  useEffect(() => {
    api.get('/material').then(r => setItems(r.data)).catch(() => {});
    api.get('/baustellen').then(r => setBaustellen(r.data)).catch(() => {});
  }, []);

  const add = async () => {
    if (editing) {
      await api.put(`/material/${editing}`, { ...form, bezeichnung: form.bezeichnung, min_bestand: form.min_bestand });
      setEditing(null);
    } else {
      await api.post('/material', form);
    }
    const r = await api.get('/material');
    setItems(r.data); setShowForm(false);
    setForm({ pos_nr: '', bezeichnung: '', einheit: 'St', bestand: '', min_bestand: '5', baustelle_id: '' });
  };

  const update = async (id, key, val) => {
    const item = items.find(i => i.id === id);
    await api.put(`/material/${id}`, { ...item, [key]: val });
    setItems(items.map(i => i.id === id ? { ...i, [key]: val } : i));
  };

  const statusBadge = item => {
    if (item.bestand <= 0) return <span className="badge badge-red">Leer</span>;
    if (item.bestand <= item.min_bestand) return <span className="badge badge-amber">Niedrig</span>;
    return <span className="badge badge-green">OK</span>;
  };

  return (
    <div>
      <div className="page-header">
        <div><div className="page-title">Materialverwaltung</div><div className="page-sub">{items.length} Positionen</div></div>
        <div style={{display:'flex', gap:8}}>
          <button className="btn btn-primary" onClick={() => setShowForm(s => !s)}>+ Position hinzufügen</button>
          <button className="btn btn-secondary" onClick={async () => {
              const standard = [
                { pos_nr: '09.01.010', bezeichnung: 'Rohr M32 Betonbau',        einheit: 'm',  bestand: 0, min_bestand: 10 },
                { pos_nr: '09.01.020', bezeichnung: 'Rohr M25 Betonbau',         einheit: 'm',  bestand: 0, min_bestand: 10 },
                { pos_nr: '09.01.030', bezeichnung: 'Geräteverbindungsdose M60', einheit: 'St', bestand: 0, min_bestand: 5  },
                { pos_nr: '09.01.040', bezeichnung: 'Leuchtendose Beton',         einheit: 'St', bestand: 0, min_bestand: 5  },
                { pos_nr: '09.01.050', bezeichnung: 'Imbeton Gegenlager',         einheit: 'St', bestand: 0, min_bestand: 5  },
                { pos_nr: '09.01.060', bezeichnung: 'Krümmer EN32',              einheit: 'St', bestand: 0, min_bestand: 5  },
                { pos_nr: '09.01.070', bezeichnung: 'Krümmer EN25',              einheit: 'St', bestand: 0, min_bestand: 5  },
                { pos_nr: '09.01.080', bezeichnung: 'Rohrauslass EN25',           einheit: 'St', bestand: 0, min_bestand: 5  },
              ];
              for (const p of standard) await api.post('/material', p).catch(()=>{});
              const r = await api.get('/material');
              setItems(r.data);
            }}>
              ⚡ Standard-Positionen importieren
          </button>
        </div>
      </div>

      {showForm && (
        <div className="card" style={{ marginBottom: 12 }}>
          <div className="card-title" style={{ marginBottom: 14 }}>{editing ? "Position bearbeiten" : "Neue Position"}</div>
          <div className="form-grid form-grid-3" style={{ marginBottom: 14 }}>
            {[['Pos.-Nr.', 'pos_nr'], ['Bezeichnung', 'bezeichnung'], ['Einheit', 'einheit']].map(([l, k]) => (
              <div className="form-group" key={k}>
                <label className="form-label">{l}</label>
                <input className="form-input" value={form[k]} onChange={e => setForm(f => ({ ...f, [k]: e.target.value }))} />
              </div>
            ))}
            <div className="form-group">
              <label className="form-label">Bestand</label>
              <input className="form-input" type="number" value={form.bestand} onChange={e => setForm(f => ({ ...f, bestand: e.target.value }))} />
            </div>
            <div className="form-group">
              <label className="form-label">Mindestbestand</label>
              <input className="form-input" type="number" value={form.min_bestand} onChange={e => setForm(f => ({ ...f, min_bestand: e.target.value }))} />
            </div>
            <div className="form-group">
              <label className="form-label">Baustelle</label>
              <select className="form-select" value={form.baustelle_id} onChange={e => setForm(f => ({ ...f, baustelle_id: e.target.value }))}>
                <option value="">Alle / Lager</option>
                {baustellen.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
              </select>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-secondary" onClick={() => { setShowForm(false); setEditing(null); setForm({ pos_nr: '', bezeichnung: '', einheit: 'St', bestand: '', min_bestand: '5', baustelle_id: '' }); }}>Abbrechen</button>
            <button className="btn btn-primary" onClick={add}>Speichern</button>
          </div>
        </div>
      )}

      <div className="card">
        {items.length === 0 ? (
          <div className="empty"><div className="empty-icon">📦</div><h3>Noch keine Materialien</h3><p>Füge deine ersten Positionen hinzu.</p></div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead><tr><th>Pos.-Nr.</th><th>Bezeichnung</th><th>Einheit</th><th>Bestand</th><th>Verbraucht</th><th>Mind.</th><th>Status</th><th></th></tr></thead>
              <tbody>
                {items.map(item => (
                  <tr key={item.id}>
                    <td style={{ fontFamily: 'monospace', fontSize: 12, color: 'var(--blue)', fontWeight: 600 }}>{item.pos_nr || '–'}</td>
                    <td style={{ fontWeight: 500 }}>{item.bezeichnung}</td>
                    <td style={{ textAlign: 'center' }}>{item.einheit}</td>
                    <td>
                      <input style={{ width: 70, padding: '4px 8px', fontSize: 13, border: '1px solid var(--border)', borderRadius: 6, fontFamily: 'monospace', fontWeight: 600, color: 'var(--blue)' }}
                        type="number" value={item.bestand}
                        onChange={e => update(item.id, 'bestand', parseFloat(e.target.value))} />
                    </td>
                    <td style={{ fontFamily: 'monospace', color: 'var(--text-2)' }}>{item.verbraucht || 0}</td>
                    <td>
                      <input style={{ width: 60, padding: '4px 6px', fontSize: 12, border: '1px solid var(--border)', borderRadius: 6 }}
                        type="number" value={item.min_bestand}
                        onChange={e => update(item.id, 'min_bestand', parseFloat(e.target.value))} />
                    </td>
                    <td>{statusBadge(item)}</td>
                    <td style={{ display: 'flex', gap: 4 }}>
                      <button className="btn btn-secondary btn-sm" onClick={() => {
                        setForm({ pos_nr: item.pos_nr||'', bezeichnung: item.bezeichnung, einheit: item.einheit, bestand: item.bestand, min_bestand: item.min_bestand, baustelle_id: item.baustelle_id||'' });
                        setEditing(item.id); setShowForm(true);
                      }}>✏️</button>
                      <button className="btn btn-danger btn-sm" onClick={async () => {
                        if (!window.confirm(`"${item.bezeichnung}" löschen?`)) return;
                        await api.delete(`/material/${item.id}`).catch(()=>{});
                        setItems(items.filter(i => i.id !== item.id));
                      }}>🗑</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// Fotos.js
// ─────────────────────────────────────────────────────────────────────────────
export function Fotos() {
  const [fotos, setFotos] = useState([]);
  const [baustellen, setBaustellen] = useState([]);
  const [editing, setEditing] = useState(null);
  const [filter, setFilter] = useState('');
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    api.get('/fotos').then(r => setFotos(r.data)).catch(() => {});
    api.get('/baustellen').then(r => setBaustellen(r.data)).catch(() => {});
  }, []);

  const handleUpload = async (e) => {
    const files = e.target.files;
    if (!files.length) return;
    setUploading(true);
    const fd = new FormData();
    for (const f of files) fd.append('fotos', f);
    if (filter) fd.append('baustelle_id', filter);
    try {
      await api.post('/fotos', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      const r = await api.get('/fotos');
      setFotos(r.data);
    } catch (e) { alert('Upload fehlgeschlagen'); }
    setUploading(false);
    e.target.value = '';
  };

  const filtered = fotos.filter(f => !filter || String(f.baustelle_id) === filter);

  return (
    <div>
      <div className="page-header">
        <div><div className="page-title">Fotodokumentation</div><div className="page-sub">{filtered.length} Fotos</div></div>
        <label className="btn btn-primary" style={{ cursor: 'pointer' }}>
          {uploading ? 'Lädt hoch…' : '+ Fotos hochladen'}
          <input type="file" accept="image/*" multiple style={{ display: 'none' }} onChange={handleUpload} />
        </label>
      </div>

      <div className="card" style={{ marginBottom: 12 }}>
        <select className="form-select" style={{ width: 280 }} value={filter} onChange={e => setFilter(e.target.value)}>
          <option value="">Alle Baustellen</option>
          {baustellen.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
        </select>
      </div>

      <div className="card">
        {filtered.length === 0 ? (
          <div className="empty"><div className="empty-icon">📷</div><h3>Keine Fotos</h3><p>Lade deine ersten Fotos hoch.</p></div>
        ) : (
          <div className="photo-grid">
            {filtered.map(f => (
              <div className="photo-item" key={f.id} onClick={() => window.open(f.url, '_blank')}>
                <img src={f.url} alt={f.beschreibung || 'Foto'} loading="lazy" />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// Baustellen.js
// ─────────────────────────────────────────────────────────────────────────────
export function Baustellen() {
  const [items, setItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: '', ort: '', abschnitt: '', status: 'aktiv' });
  const [editing, setEditing] = useState(null);

  useEffect(() => { api.get('/baustellen').then(r => setItems(r.data)).catch(() => {}); }, []);

  const save = async () => {
    if (editing) { await api.put(`/baustellen/${editing}`, form); }
    else { await api.post('/baustellen', form); }
    const r = await api.get('/baustellen'); setItems(r.data);
    setShowForm(false); setEditing(null); setForm({ name: '', ort: '', abschnitt: '', status: 'aktiv' });
  };

  const startEdit = (item) => { setForm({ name: item.name, ort: item.ort || '', abschnitt: item.abschnitt || '', status: item.status }); setEditing(item.id); setShowForm(true); };

  const statusBadge = s => {
    if (s === 'aktiv') return <span className="badge badge-green">Aktiv</span>;
    if (s === 'pause') return <span className="badge badge-amber">Pause</span>;
    return <span className="badge badge-grey">Fertig</span>;
  };

  return (
    <div>
      <div className="page-header">
        <div><div className="page-title">Baustellen</div><div className="page-sub">{items.length} Projekte</div></div>
        <button className="btn btn-primary" onClick={() => { setShowForm(s => !s); setEditing(null); setForm({ name: '', ort: '', abschnitt: '', status: 'aktiv' }); }}>+ Neue Baustelle</button>
      </div>

      {showForm && (
        <div className="card" style={{ marginBottom: 12 }}>
          <div className="card-title" style={{ marginBottom: 14 }}>{editing ? 'Baustelle bearbeiten' : 'Neue Baustelle'}</div>
          <div className="form-grid form-grid-2" style={{ marginBottom: 14 }}>
            <div className="form-group"><label className="form-label">Name / Projekt</label><input className="form-input" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} /></div>
            <div className="form-group"><label className="form-label">Ort</label><input className="form-input" value={form.ort} onChange={e => setForm(f => ({ ...f, ort: e.target.value }))} /></div>
            <div className="form-group"><label className="form-label">Abschnitt / Bereich</label><input className="form-input" value={form.abschnitt} onChange={e => setForm(f => ({ ...f, abschnitt: e.target.value }))} /></div>
            <div className="form-group"><label className="form-label">Status</label>
              <select className="form-select" value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))}>
                <option value="aktiv">Aktiv</option><option value="pause">Pause</option><option value="fertig">Fertig</option>
              </select>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-secondary" onClick={() => { setShowForm(false); setEditing(null); setForm({ pos_nr: '', bezeichnung: '', einheit: 'St', bestand: '', min_bestand: '5', baustelle_id: '' }); }}>Abbrechen</button>
            <button className="btn btn-primary" onClick={save}>Speichern</button>
          </div>
        </div>
      )}

      <div className="card">
        {items.length === 0 ? (
          <div className="empty"><div className="empty-icon">🏗</div><h3>Keine Baustellen</h3><p>Lege deine erste Baustelle an.</p></div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead><tr><th>Name</th><th>Ort</th><th>Abschnitt</th><th>Status</th><th>Erstellt</th><th></th></tr></thead>
              <tbody>
                {items.map(item => (
                  <tr key={item.id}>
                    <td style={{ fontWeight: 600 }}>{item.name}</td>
                    <td>{item.ort || '–'}</td>
                    <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{item.abschnitt || '–'}</td>
                    <td>{statusBadge(item.status)}</td>
                    <td style={{ fontSize: 12, color: 'var(--text-2)' }}>{item.created_at?.slice(0, 10)}</td>
                    <td><button className="btn btn-secondary btn-sm" onClick={() => startEdit(item)}>Bearbeiten</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// Mitarbeiter.js  (Admin only)
// ─────────────────────────────────────────────────────────────────────────────
export function Mitarbeiter() {
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ username: '', password: '', name: '', role: 'monteur' });
  const [editing, setEditing] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => { api.get('/users').then(r => setUsers(r.data)).catch(() => {}); }, []);

  const save = async () => {
    setError('');
    try {
      if (editing) await api.put(`/users/${editing}`, form);
      else await api.post('/users', form);
      const r = await api.get('/users'); setUsers(r.data);
      setShowForm(false); setEditing(null); setForm({ username: '', password: '', name: '', role: 'monteur' });
    } catch (e) { setError(e.response?.data?.error || 'Fehler'); }
  };

  const del = async (id) => {
    if (!window.confirm('Mitarbeiter wirklich löschen?')) return;
    await api.delete(`/users/${id}`);
    setUsers(users.filter(u => u.id !== id));
  };

  const startEdit = (u) => { setForm({ username: u.username, password: '', name: u.name, role: u.role }); setEditing(u.id); setShowForm(true); };

  return (
    <div>
      <div className="page-header">
        <div><div className="page-title">Mitarbeiter</div><div className="page-sub">{users.length} Accounts</div></div>
        <button className="btn btn-primary" onClick={() => { setShowForm(s => !s); setEditing(null); setForm({ username: '', password: '', name: '', role: 'monteur' }); }}>+ Mitarbeiter hinzufügen</button>
      </div>

      {showForm && (
        <div className="card" style={{ marginBottom: 12 }}>
          <div className="card-title" style={{ marginBottom: 14 }}>{editing ? 'Mitarbeiter bearbeiten' : 'Neuer Mitarbeiter'}</div>
          {error && <div style={{ background: 'var(--red-bg)', color: 'var(--red)', padding: '8px 12px', borderRadius: 'var(--radius)', marginBottom: 12, fontSize: 13 }}>{error}</div>}
          <div className="form-grid form-grid-2" style={{ marginBottom: 14 }}>
            <div className="form-group"><label className="form-label">Name</label><input className="form-input" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} /></div>
            <div className="form-group"><label className="form-label">Benutzername</label><input className="form-input" value={form.username} onChange={e => setForm(f => ({ ...f, username: e.target.value }))} disabled={!!editing} /></div>
            <div className="form-group"><label className="form-label">{editing ? 'Neues Passwort (leer = unverändert)' : 'Passwort'}</label><input className="form-input" type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} /></div>
            <div className="form-group"><label className="form-label">Rolle</label>
              <select className="form-select" value={form.role} onChange={e => setForm(f => ({ ...f, role: e.target.value }))}>
                <option value="monteur">Monteur</option><option value="admin">Administrator</option>
              </select>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-secondary" onClick={() => { setShowForm(false); setEditing(null); setForm({ pos_nr: '', bezeichnung: '', einheit: 'St', bestand: '', min_bestand: '5', baustelle_id: '' }); }}>Abbrechen</button>
            <button className="btn btn-primary" onClick={save}>Speichern</button>
          </div>
        </div>
      )}

      <div className="card">
        <div className="table-wrap">
          <table>
            <thead><tr><th>Name</th><th>Benutzername</th><th>Rolle</th><th>Erstellt</th><th></th></tr></thead>
            <tbody>
              {users.map(u => (
                <tr key={u.id}>
                  <td style={{ fontWeight: 600 }}>{u.name}</td>
                  <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{u.username}</td>
                  <td>{u.role === 'admin' ? <span className="badge badge-blue">Admin</span> : <span className="badge badge-grey">Monteur</span>}</td>
                  <td style={{ fontSize: 12, color: 'var(--text-2)' }}>{u.created_at?.slice(0, 10)}</td>
                  <td style={{ display: 'flex', gap: 6 }}>
                    <button className="btn btn-secondary btn-sm" onClick={() => startEdit(u)}>Bearbeiten</button>
                    <button className="btn btn-danger btn-sm" onClick={() => del(u.id)}>Löschen</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Material;
